// The shared half of every tool's table (unify-ui ship 3): the leaves two or more tools hold with
// the same words — deduped into the package, composed under each tool's own table by compose()
// (@3dp/ui/i18n); the tool's own table keeps what is its alone. Thai is today's wording, character
// for character (ruling R18). packages/ui/test/strings.test.js holds this file's shape; each tool's
// test/tables.test.js holds its composed table to English's key set, kinds and placeholders.
export const SHARED_EN = {
  back: "Tools",   // the home link's word; its arrow is the template's (R70: at the phone layout the link shows the arrow alone, this word is its aria-label)
  text: "Text",
  font: "Font",
  dl3mf: "Download 3MF",
  share: "Copy link",
  updating: "Calculating…",
  exportFail: "Download failed",
  useFont: (family, mb) => `Use ${family} (${mb} MB)`,
  pickFromList: "Another family in the font list may have them",   // R83: after the offered family, what it lacks — the list holds the others
  fontFailed: (family) => `Could not load ${family} — check the connection · keeping the current font`,
  fontNotOffered: (asked) => `This link uses the font ${asked}, which this page does not have — using Kanit instead`,
  pick: "Choose an SVG file",
  reading: "Reading the file…",
  notSvg: "Only SVG files are supported — in Illustrator choose Export As → SVG and convert text to outlines first",
  svgTooBig: "The file is too large or too detailed — reduce the number of points or merge shapes, and export a fresh SVG",
  svgEmpty: "No filled shapes found in this file — convert strokes and text to outlines first",
  svgBad: "This file could not be read — it is not a usable SVG",
  readFail: "The file could not be read — try choosing it again",
  skipped: {
    background: (n) => `${n} backgrounds — removed`,
    bad: (n) => `${n} unreadable shapes — skipped`,
    clipped: (n) => `${n} shapes with a clip or mask — the whole shape is used, not cut by the clip`,
    hidden: (n) => `${n} hidden parts — not used`,
    image: (n) => `${n} images — only vector shapes are usable`,
    stroke: (n) => `${n} strokes without a fill — convert strokes to outlines first`,
    stroked: (n) => `${n} shapes with a stroke — the stroke’s width is not included`,
    text: (n) => `${n} text elements — convert to outlines first`,
  },
  badLink: "This link is not usable — the default design is open instead",
  newerLink: "This link came from a newer version — the default design is open instead",
  buildFail: "The calculation failed — try adjusting the values again",
  lineHint: "Open in a browser to download",
  shareNoLogo: "This link carries no logo file — whoever opens it must choose the SVG themselves",
  linkNeedsLogo: "This design uses a logo from a file, which the link does not carry — choose an SVG file to add it",
  h: "Height (mm)",
  numHint: (lo, hi) => `Enter a number ${lo}–${hi}`,
  percent: (v) => `${Math.round(v * 100)}%`,
  slot: (n) => `Slot ${n}`,
  parts: {
    lid: "Lid",
  },
  fits: {
    loose: "Loose",
  },
  finishes: {
    engraved: "Engraved",
  },
  lookNames: {
    filasophy: "Filasophy",
  },
  viewGroup: "View",
  sources: {
    none: "None",
    svg: "SVG file",
    text: "Text",
  },
  mood: {
    all: "All",
    bold: "Bold",
    cute: "Cute",
    handwritten: "Handwritten",
    neat: "Neat",
    tech: "Tech",
  },
  problem: {
    "missing-chars": (p) => `This font lacks the characters ${p.chars.slice(0, 12).join(' ')}`,
    "text-too-complex": "The text is too detailed — try fewer characters or another font; no download",
  },
  noGl: "This browser cannot show 3D, but downloading still works",
  needFileLine: "Downloads do not work inside LINE — open this page in a browser first, then choose the file",
  machineNote: null,   // the ja/zh-CN/zh-TW tables carry the "machine-written, unread" line; en/th render nothing

  // ship 3 piece c: the template's static text, baked per language by the build (was hardcoded Thai)
  undo: "Undo",
  redo: "Redo",
  // ship 3 piece f (ruling R21): the language switch, its cannot-carry note, and the English-page offer
  langSwitchLabel: "Language",
  switchNoFile: "The link carries no uploaded file — it must be chosen again after the switch",
  offerLine: null,      // the offer line is the OFFERED language's words; English is never offered (en pages only)
  offerDismiss: "Hide this offer",   // the offer mounts on English pages only, so its dismiss label is English
  // the font control and the font sheet (@3dp/ui font-control.js, picker.js — unify-ui ship 4a, moved from name-tag)
  pickFont: "Choose a font",
  close: "Close",
  weight: "Font weight",
  weightName: (w) => `${w} ${{ 100: 'Ultra thin', 200: 'Extra thin', 300: 'Thin', 400: 'Regular', 500: 'Medium', 600: 'Semibold', 700: 'Bold', 800: 'Extra bold', 900: 'Ultra bold' }[w] || ''}`.trim(),
  scriptName: {
    latin: "Latin",
    thai: "Thai",
    japanese: "Japanese",
    "chinese-simplified": "Simplified Chinese",
    "chinese-traditional": "Traditional Chinese",
    han: "Chinese/Japanese",
    other: "Other scripts",
  },
  chipRemove: "Show fonts of every script",
  chipMark: "×",
  noFontForText: "No font covers this text — try another script",
  noFontInMood: "No fonts in this group",
  fontLoadFailed: "Could not load — check the connection",
  sample: {
    japanese: "名札",
    "chinese-simplified": "名牌",
    "chinese-traditional": "名牌",
  },
  moreFonts: "More fonts (Google Fonts)",
  backToCurated: "← Recommended fonts",
  searchFonts: "Search fonts",
  category: {
    all: "All",
    "sans-serif": "Sans serif",
    serif: "Serif",
    display: "Display",
    handwriting: "Handwriting",
    monospace: "Monospace",
  },
  untested: "Not yet print-tested",
  noFontFound: "No fonts found — try another word or category",
  catalogLoading: "Loading the font list…",
  catalogFailed: "Could not load the font list — check the connection",
  mb: (mib) => `${mib.toFixed(1)} MB`,
  // the colour control (@3dp/ui colours.js — unify-ui ship 4b, moved from name-tag): the own-colour input, an own colour's caption
  customColor: "Custom…",
  customCaption: "Custom",
};
